import PropTypes from 'prop-types';
import React from 'react';
import { ActionSheet } from 'components/v3';

// The unsaved-changes guard's sheet (plan §5.5): Save and leave, Discard
// changes, Keep editing. A bottom sheet on phones, a dialog on desktop.
const LeaveSheet = ({ open, count, onSave, onDiscard, onKeep }) => (
  <ActionSheet
    open={open}
    onClose={onKeep}
    title="You have unsaved changes"
    subtitle={`${count} unsaved change${count === 1 ? '' : 's'} to this form.`}
    cancelLabel="Keep editing"
    items={[
      { key: 'save', label: 'Save and leave', icon: 'save', primary: true },
      {
        key: 'discard',
        label: 'Discard changes',
        icon: 'trash-2',
        danger: true,
      },
    ]}
    onSelect={(key) => (key === 'save' ? onSave() : onDiscard())}
  />
);

LeaveSheet.propTypes = {
  open: PropTypes.bool.isRequired,
  count: PropTypes.number.isRequired,
  onSave: PropTypes.func.isRequired,
  onDiscard: PropTypes.func.isRequired,
  onKeep: PropTypes.func.isRequired,
};

export default LeaveSheet;
